import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewHolding, updateHolding } from '../../../../slices/holding/thunk';
import { setRequireCloseModal } from '../../../../slices/holding/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import RolesSelect from '../../../../Components/General/Selects/RolesSelect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { getCommuneList, getCompanyList, getHoldingTypeList, getProductiveAreaList, getSanitaryVicinityList } from '../../../../helpers/establishment/backend_helper';
import OInput from '../../../../Components/OElements/OInput';

const HoldingForm = ({
	dataHolding,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const selectorHolding = createSelector(
		state => state.Holdings,
		holding => ({
			isAdding: holding.isAdding,
			isAdded: holding.isAdded,
			isUpdating: holding.isUpdating,
			isUpdated: holding.isUpdated,
			isLoadingList: holding.isLoadingList,
			requireCloseModal: holding.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorHolding);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			name: (dataHolding && dataHolding.name) || '',
			disabled: (dataHolding && dataHolding.disabled) || false,
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
		}),
		onSubmit: values => {
			console.log('??')
			if (isEdit) {
				const updatedHolding = {
					_id: dataHolding._id,
					name: values.name,
					disabled: values.disabled
				};
				dispatch(updateHolding(updatedHolding));
			} else {
				const newHolding = {
					name: values.name,
					disabled: values.disabled
				};
				dispatch(addNewHolding(newHolding));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={12}>
								<OInput
									name='name'
									label='Nombre del Holding'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Holding
					</button>
				</div>
			</div>
		</Form>
	);
};

export default HoldingForm;
